/**
 * @class
 * @extends RoadgamesEvent.Base
 */
RoadgamesEvent.Any = Class(
	/**
	 * @lends {RoadgamesEvent.Any#}
	 */
	{
		_draw() {
			this._drawWelcome();
			this._drawTopSponsors();
			this._drawInfoBlock();
			this._drawApiGallery();
			this._drawTasksSlider();
			this._drawSteps();
			this._drawPrizeSponsors();
			this._drawInstagramFeed();
			this._drawTestimonials();
			this._drawExperience();
			this._drawGiftCards();
			this._drawFaq();
			this._drawCta();
		},

		_drawFaq() {
			new T.FAQ({
				title: t('b2b.events.faq.title'),
				prefix: 'b2b.events.faq',
				className: 'container mb-5'
			}).append(this.node);
		},

		_drawWelcomeBottom() {
			return mkE({
				tag: 'div',
				className: 'single-event-welcome-purchase',
				els: [
					{
						tag: 'div',
						className: 'button-container',
						els: [
							this._buyBtn = mkE({
								tag: 'a',
								href: D.url(`/contact-us?f=event_${this.event.id}`),
								className: 'button button-pink',
								text: D.Lang.get('b2b.event.register')
							})
						]
					},
					{
						tag: 'div',
						className: 'price-container',
						els: [
							{
								tag: 'div',
								className: 'price',
								innerHTML: t('b2b.event.price', 'from <b>%PRICE%</b>').replace('%PRICE%', '<b>€750.00</b>')
							}
						]
					}
				]
			});
		},

		_drawCta() {
			this._cta = new T.CallToAction({
				className: 'single-event-cta',
				els: [
					{
						tag: 'div',
						className: 'button-container',
						els: [
							{
								tag: 'a',
								href: D.url(`/contact-us?f=event_cta_${this.event.id}`),
								className: 'button button-pink',
								text: D.Lang.get('b2b.event.register')
							}
						]
					},
					{
						tag: 'div',
						className: 'price-container',
						els: [
							{
								tag: 'div',
								className: 'price',
								innerHTML: t('b2b.event.price', 'from <b>%PRICE%</b>').replace('%PRICE%', '€750.00')
							}
						]
					}
				]
			}).append(document.body);
		},

		onLeave: function () {
			PARENT.onLeave();
			if( this._cta ) {
				this._cta.remove();
				this._cta = null;
			}
		},

		onScroll() {
			if( this._cta && this._buyBtn ) {
				if( screen.width < 720 || this._buyBtn.offsetTop + 200 < window.scrollY ) {
					if( !this._cta.active ) {
						this._cta.show();
					}
				} else if( this._cta.active ) {
					this._cta.hide();
				}
			}
		},

	},
	RoadgamesEvent.Base
);
